<template>
    <form v-loading="loading" @submit.prevent="submit">
        <validation-errors :error="validationErrors" />
        <slot />

        <div v-if="successMessage" class="text-success mb-xl">
            <font-awesome-icon icon="check-circle" />
            {{ successMessage }}
        </div>
        <div v-else-if="hasError" class="text-danger mb-xl">
            <font-awesome-icon icon="exclamation-circle" />
            {{ lang(
                'Ojdå! Det gick inte att skicka formuläret. Kontrollera alla fält och försök igen, eller kontakta',
                'Whoops! The form could not be sent. Check all fields and try again or contact'
            ) }} <a :href="route('front.customer-service.index')">{{ lang('kundservice','customer service') }}</a>
        </div>
        <button
            type="submit"
            :class="submitBtnClasses"
            class="btn btn-lg is-primary mb-2xl md:mb-0"
        >
            {{ sendButtonText }}
        </button>
    </form>
</template>

<script>
    import ValidationErrors from './ValidationErrors';

    export default {
        components: {
            ValidationErrors,
        },
        props: {
            action: {
                type: String,
                required: true,
            },
            sendButtonText: {
                type: String,
                default: lang('Skicka','Send'),
            },
            submitBtnClasses: {
                type: String,
                required: false,
                default: '',
            },
        },
        data() {
            return {
                loading: false,
                successMessage: null,
                hasError: false,
                validationErrors: {},
            };
        },
        methods: {
            async submit() {
                try {
                    this.loading = true;
                    const formData = new FormData(this.$el);
                    const response = await axios.post(this.action, formData);
                    this.successMessage = response.data.message;
                    this.validationErrors = {};
                    this.hasError = false;
                    this.clearForm();
                    this.$emit('submitted');
                } catch (error) {
                    this.successMessage = false;
                    if (error.response.status === 422 && error.response.data.errors) {
                        this.validationErrors = error.response.data;
                    } else {
                        this.hasError = true;
                    }

                    this.$emit('error');
                }

                this.loading = false;
            },
            clearForm() {
                Array.from(this.$el.querySelectorAll('.form-group, button[type="submit"]')).forEach(element => element.style.display = 'none');
            },
        },
    };
</script>
